module.exports = __webpack_public_path__ + "static/media/placeholder_noimage.c1fef6b6.png";